import { render, staticRenderFns } from "./PmReportGnbTemplate.vue?vue&type=template&id=2d6918d9&"
import script from "./PmReportGnbTemplate.vue?vue&type=script&lang=js&"
export * from "./PmReportGnbTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports